import api from '@/services/api';

export default {
  namespaced: true,
  state: {
    ticketTypes: null,
    reportReasons: [],
  },
  mutations: {
    updateTicketTypes(state, payload) {
      state.ticketTypes = payload;
    },
    setReportReasons(state, data) {
      state.reportReasons = data.reasons || [];
    },
  },
  actions: {
    getForumUrl() {
      return api.support.getForumUrl()
        .then(response => response.data);
    },
    getTicketsTypes({ commit }) {
      return api.support.getTicketsTypes()
        .then(response => commit('updateTicketTypes', response.data.map(o => ({ label: o, value: o }))));
    },
    postTicket({ commit }, payload) {
      return api.support.postTicket(payload);
    },
    getReportUserReasons({ state, commit }, { cache = true } = {}) {
      if (cache && state.reportReasons.length > 0) {
        return Promise.resolve(state.reportReasons);
      }
      return api.support.getReportUser()
        .then((response) => {
          commit('setReportReasons', response.data);
          return response.data;
        });
    },
    reportUser({ commit }, payload) {
      return api.support.postReportUser(payload)
        .then(response => response.data);
    },
    getAnnouncements() {
      return api.support.getAnnouncements()
        .then(response => response.data);
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/support.js